import $ from 'jquery';
import LoadNextItem from './load_next_item';
import magnificPopup from 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';
import './oembed';

export function renderGallery(selector) {
    if (typeof selector != 'object') {
        selector = $(selector);
    }
    if (selector.length == 0) {
        return;
    }

    selector.magnificPopup({
        delegate: 'a', // child items selector, by clicking on it popup will open
        index: 3,
        type: 'image',
        gallery: {
            // options for gallery
            enabled: true
        },
        image: {
            // options for image content type
            titleSrc: 'title'
        },
        zoom: {
            enabled: true, // By default it's false, so don't forget to enable it

            duration: 300, // duration of the effect, in milliseconds
            easing: 'ease-in-out', // CSS transition easing function
            // The "opener" function should return the element from which popup will be zoomed in
            // and to which popup will be scaled down
            // By defailt it looks for an image tag:
            opener: function (openerElement) {
                // openerElement is the element on which popup was initialized, in this case its <a> tag
                // you don't need to add "opener" option if this code matches your needs, it's defailt one.
                return openerElement.is('img') ? openerElement : openerElement.find('img');
            }
        }



        // other options
    });
};

$.fn.item = function (options) {
    let defaultPage = $('.default-page');
    renderGallery('.default-item__gallery');
    $('.lazy').Lazy({
        afterLoad: function (element) {
            $(element).addClass('lazy--loaded');
            $(element).parents('.has-lazy')
                .show('fast')
                .css('padding', 0)
                .removeClass('spinner')
                .removeClass('has-lazy');

            let _root = $(element).parents('.default-item__media');
            if (_root.length && _root.find('.default-item__image__desc').length) {
                _root.find('.default-item__image').css({
                    width: _root.find('.default-item__image img').css('width')
                })
            }
        },
    });
    defaultPage.on('click', '.default-item--has-video .default-item__video__image a', function () {
        let _videoUrl = $(this).data('video');
        if (!_videoUrl || !_videoUrl.length) {
            return false;
        }

        $(this).parents('.default-item__video').append('<iframe src="' + _videoUrl + '" width="' + $(this).data('width') + '" height="' + $(this).data('height') + '"></iframe>');

        $(this).parents('.default-item__video__image a').slideDown('slow', function () {
            $(this).remove();
        });

        return false;
    });

    defaultPage.on('click', '.item-action__font-size button', function () {
        let currentSize = $(this).parents('.default-item__body').find('.default-item__content').css('font-size');
        currentSize = parseInt(currentSize, 10);
        if ($(this).data('action') === 'increase') {
            currentSize++;
        } else {
            currentSize--;
        }
        if (currentSize < 14) {
            currentSize = 14;
        } else if (currentSize > 20) {
            currentSize = 20;
        }

        defaultPage.find('.default-item__body .default-item__content').stop().animate({
            fontSize: currentSize + 'px'
        }, 300);
    });

    /**
     * Load more
     */

    if (typeof _item_infinite_scroll_settings !== 'undefined') {
        if (typeof _pageParams === 'undefined') {
            let _pageParams = [];
        }
        new LoadNextItem('#items-wrapper', _item_infinite_scroll_settings, _pageParams);
    }

};


export default class Item {
    constructor(selector, options = {}) {
        $(selector).item(options)
    }
}



// WEBPACK FOOTER //
// ./src/scripts/item.js